<div class="widgets-container">
  @for (widget of widgets; track widget) {
    <ng-container
      *ngTemplateOutlet="widgetTemplate; context: { $implicit: widget }"
    ></ng-container>
  }
</div>

<ng-template #widgetTemplate let-data>
  <sh-card card-height="80px">
    <div class="body-card">
      <div class="card-label">
        <sh-icon
          color="#EC6602"
          size="m"
          icon="{{ data.icon }}"
          id="{{ data.icon }}-icon"
        ></sh-icon>
        <div>
          <sh-text size="header-2">
            {{ data.header | translate }}
          </sh-text>
          @if (data.subheader) {
            <sh-text color="secondary"> {{ data.subheader }} </sh-text>
          }
        </div>
      </div>
      @if (data.count !== undefined) {
        <sh-text class="card-value">{{ data.count ?? 0 }}</sh-text>
      }
    </div>
  </sh-card>
</ng-template>
